// extracted by mini-css-extract-plugin
module.exports = {"container":"cookies_container__2fA4J","wrapper":"cookies_wrapper__knXYt","content":"cookies_content__eV-Pi","title":"cookies_title__1bA2e","subtitles":"cookies_subtitles__2RT_F"};